import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'https://argecosmetics.co.uk';

// Reusable SEO head: title, description, canonical, Open Graph, optional JSON-LD.
const Seo = ({ title, description, path = '', image, type = 'website', jsonLd }) => {
  const fullTitle = title ? `${title} | ARGE Cosmetics` : 'ARGE Cosmetics | Private Label Manufacturing & Store';
  const url = `${SITE}${path}`;
  const img = image
    ? (/^https?:/.test(image) ? image : `${SITE}${image.startsWith('/') ? '' : '/'}${image}`)
    : `${SITE}/og-image.jpg?v=2`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
